// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__D9F1g","step":"styles_step__Y9B3Z","label":"styles_label__JtOtJ"};